export const language = {
  tooltipLabel: 'کپی',
  successLabel: 'کپی شد',
  copyFailed: 'Copy failed:',
};
